import { render, staticRenderFns } from "./AGCEditGroupInput.vue?vue&type=template&id=0b3667cd&scoped=true&"
import script from "./AGCEditGroupInput.vue?vue&type=script&lang=js&"
export * from "./AGCEditGroupInput.vue?vue&type=script&lang=js&"
import style0 from "./AGCEditGroupInput.vue?vue&type=style&index=0&id=0b3667cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3667cd",
  null
  
)

export default component.exports